import fetch from '../../../Api/userUpdate';
import useTranslation from '../../../Hooks/useTranslation';

const useUpdate = ({ data, cancel, allEmployees, setAllEmployees }) => {
  const { t } = useTranslation();
  const handleClick = async () => {
    const status = !(data[5] === t('Generic.Active'));
    const id = data[data.length - 2];
    const response = await fetch({ status, id }).catch(err => err);

    if (!response.error) {
      allEmployees.map((employee, index) => {
        if (employee[9] === id) {
          allEmployees[index][5] = status ? t('Generic.Active') : t('Generic.Inactive');
          const newAllEmployees = allEmployees;
          setAllEmployees(newAllEmployees);
        }
        return null;
      });
    }
    cancel();
  };

  return {
    handleClick,
  };
};

export default useUpdate;
